export const classNameIfDefined = (className: any, orClassName = '') => {
  return className !== undefined && className !== null
    ? className
    : orClassName;
}